module.exports = __webpack_public_path__ + "img/12-11.264a67a5.png";